import { render, staticRenderFns } from "./MappingModel.vue?vue&type=template&id=a767af66&scoped=true"
import script from "./MappingModel.vue?vue&type=script&lang=js"
export * from "./MappingModel.vue?vue&type=script&lang=js"
import style0 from "./MappingModel.vue?vue&type=style&index=0&id=a767af66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a767af66",
  null
  
)

export default component.exports